module.exports = __webpack_public_path__ + "img/logo.9a6b32e.svg";